import gql from 'graphql-tag';

export const addCoachingComment = gql`
  mutation AddCoachingComment(
    $noteID: String!
    $coachingID: String!
    $authorAlias: String!
    $comment: String!
    $notificationReceivers: [String!]!
    $owner: String!
    $commentThreadType: String!
    $receiverAlias: String!
  ) {
    addCoachingComment(
      noteID: $noteID
      coachingID: $coachingID
      authorAlias: $authorAlias
      comment: $comment
      notificationReceivers: $notificationReceivers
      owner: $owner
      commentThreadType: $commentThreadType
      receiverAlias: $receiverAlias
    )
  }
`;
